import React from 'react';
import {useContext} from "react"
import './BackDrop.css';
import SimpleContext from './../context/SimpleContext';

const BackDrop = () => {
    const context = useContext(SimpleContext);
    return (  
        <div className="back-drop" onClick={context.drawerToggleClickHandler}/>
    );
}
 
export default BackDrop;
